import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'so0015',
    ecrans: ['00-2'],
    params: ["?stocleint"]
});
